import React from 'react';
import { reduxForm, Field, isDirty } from 'redux-form';
import { connect } from 'react-redux';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';
import { ActionBarWrapper } from 'components/wrappers/pages';
import {
  onChangeKeyword,
  exportSupplier,
  onClickCreateSupplier,
} from 'actions/inventory/supplier';
import { askConfirmAction } from 'actions/confirm-action';
import * as clevertapInventorySuppliers from 'clevertap/inventory/suppliers';
import MenuTitle from 'components/MenuTitle';
import { isFullSiteMode } from 'utils/fullSite';
import styles from './ActionBar.css';

class ActionBar extends React.Component {
  constructor() {
    super();
    this.state = {
      keyword: '',
    };
  }

  render() {
    return (
      <div>
        <MenuTitle menuTitle="Suppliers" />
        <div
          className="col-sm-4 hidden-xs col-md-6 action-suppliers"
          style={{ paddingRight: 0 }}
        >
          <span className="pull-right">
            {!isFullSiteMode() && (
              <button className="btn btn-primary" onClick={this._onClickExport}>
                Export
              </button>
            )}
            <button
              className="btn btn-primary ml-10px"
              onClick={this._onClickCreateSupplier}
            >
              Create Supplier
            </button>
          </span>
        </div>
        <ActionBarWrapper>
          <div
            className="col-sm-12 col-xs-12 search-suppliers"
            style={{ paddingLeft: 0 }}
          >
            <form className={`form-inline ${styles['action-bar']}`}>
              <div className="form-group mr-5px">
                <Field
                  component={SearchBar}
                  name="keyword"
                  onChange={this._onChangeKeyword}
                  placeholder="Search"
                />
              </div>
            </form>
          </div>
        </ActionBarWrapper>
      </div>
    );
  }

  _onClickExport = () => {
    const {
      dispatch,
      profile: { email },
    } = this.props;
    const { keyword } = this.state;
    clevertapInventorySuppliers.inventorySupplierExport();
    const filename = `Inventory Suppliers - ${email}`;

    dispatch(exportSupplier({ email, keyword }, filename));
  };

  _onClickCreateSupplier = () => {
    const { dispatch, isDirtySupplier } = this.props;
    if (isDirtySupplier) {
      dispatch(askConfirmAction(onClickCreateSupplier()));
    } else {
      dispatch(onClickCreateSupplier());
    }
  };

  /**
   * Redux form auto convert array to objects, so we change it back to array
   * @private
   * @param outletIdsAsObject
   */
  _onChangeOutletIds = outletIdsAsObject => {
    Object.keys(outletIdsAsObject).map(i => outletIdsAsObject[i]);
  };

  _onChangeDate = () => {};

  _onChangeKeyword = (event, keyword) => {
    const { dispatch } = this.props;
    this.setState({ keyword });
    dispatch(onChangeKeyword(keyword));
  };
}

const mapForm = {
  form: 'search',
};

function mapStateToProps(state) {
  const {
    outlets,
    outletIds,
    profile,
    isExportLoading,
  } = state.inventory.supplier;
  return {
    outlets,
    outletIds,
    profile,
    isExportLoading,
    isDirtySupplier: isDirty('supplier')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm(mapForm)(ActionBar));
